<template>
  <div
    v-click-outside="close"
    class="booking__input w-100"
    :class="{
      'is-open': showList,
      'booking__item-inner--first-item': label === 'مبدا',
    }"
  >
    <label class="booking__input-label">{{ label }}</label>
    <div class="booking__input-inner" @click="showDefaultHotels">
      <span :class="{ 'is-ltr': !(!inputValue.length && isRtl) }">
        {{ inputValue ? inputValue : title }}
      </span>
    </div>

    <div class="booking__list" :class="{ isLtr: destinationType === 1 }">
      <div class="booking__item-header hide-in-desktop">
        <span>{{ header }}</span>

        <button @click="close">
          <i class="icon-close" />
        </button>
      </div>

      <div class="booking__list-input form">
        <div
          class="form-element-group form-element-group--with-icon form-element-group--icon-right"
        >
          <div>
            <i class="icon-search" />
            <input
              type="text"
              v-model="inputValue"
              placeholder="نام شهر را جستجو کنید ..."
              class="js-destination-item"
              ref="innerInput"
              @input="searchHotelOnInputChange"
              @keyup.esc="close"
              :class="{ 'dir-ltr': !isRtl }"
              autocomplete="off"
            />
          </div>
        </div>
      </div>

      <div class="booking__list-inner">
        <div v-if="showLoading" class="booking__list-loading">
          <svg
            class="circle-loading"
            viewBox="0 0 120 120"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle class="internal-circle" cx="60" cy="60" r="30"></circle>
            <circle class="external-circle" cx="60" cy="60" r="50"></circle>
          </svg>
        </div>

        <div v-if="!showLoading">
          <div v-if="hotelList.length" class="booking__list-item">
            <ul>
              <li
                v-for="hotel in hotelList"
                :key="hotel.key"
                class="booking__result"
              >
                <div class="booking__result-content" @click="setValue(hotel)">
                  <i
                    class="booking__result-icon"
                    :class="
                      hotel.locationType === 2
                        ? 'icon-bed'
                        : 'icon-location-fill'
                    "
                  />

                  <div class="booking__result-inner">
                    <span>{{ hotel.title }}</span>
                    <label>
                      {{
                        hotel.destinationType === 2
                          ? hotel.locationType === 2
                            ? hotel.cityTitle
                            : ""
                          : hotel.locationType === 2
                          ? hotel.countryTitle + " , " + hotel.cityTitle
                          : hotel.countryTitle
                      }}</label
                    >
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <span class="booking__validation" v-if="message.length">
            {{ message }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRequest } from "../../../../Helpers/api";
import { clickOutside } from "../../../../Helpers/directives";
import { modelMapper } from "../../../../Mappers";

// select html tag
const root = document.getElementsByTagName("html")[0];

export default {
  name: "Destination",

  props: {
    destinationType: {
      type: Number,
    },

    title: {
      type: String,
    },

    label: {
      type: String,
    },

    header: {
      type: String,
    },
  },

  data() {
    return {
      inputValue: "",

      showList: false,

      hotelList: [],

      defaultList: [],

      showDefaultList: true,

      notFound: false,

      selectedHotel: false,

      hotel: "",

      baseUrl: "/hotelBooking-api/searchtitle/",

      showLoading: false,

      isRtl: true,

      temp: "",

      timeout: "",

      message: "",
    };
  },

  methods: {
    // show hotels list
    showDefaultHotels() {
      this.$emit("scroll-to-booking-section", this.$el);

      this.showList = true;
      this.temp = this.inputValue;
      this.inputValue = "";

      // set default hotel from admin
      if (
        window.externalHotelList &&
        window.externalHotelList.length &&
        this.destinationType == 1
      ) {
        this.defaultList = modelMapper(window.externalHotelList);
      }

      if (
        window.internalHotelList &&
        window.internalHotelList.length &&
        this.destinationType == 2
      ) {
        this.defaultList = modelMapper(window.internalHotelList);
      }

      if (window.innerWidth < 993) {
        root.classList.add("no-scroll");
      }

      if (!this.defaultList.length) {
        this.searchHotel();
      } else {
        this.hotelList = this.defaultList;
      }

      this.showDefaultList = true;

      this.timeout = setTimeout(() => {
        this.$refs.innerInput.focus();
        clearTimeout(this.timeout);
      }, 50);
    },

    // search hotel when type in input
    searchHotel() {
      this.showLoading = true;
      this.showDefaultList = false;
      this.showList = true;

      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.getHotelList();

        this.showLoading = false;

        this.$refs.innerInput.focus();
      }, 400);
    },

    // search city on input changed
    searchHotelOnInputChange() {
      if (this.inputValue.length) {
        this.searchHotel();
      } else {
        this.showDefaultList = true;
        this.hotelList = this.defaultList;
        this.notFound = false;
        this.message = "";
      }
    },

    // get city list
    getHotelList() {
      this.hotelList = [];
      this.message = "";
      this.notFound = false;

      let payload = {
        url: this.baseUrl + this.inputValue + "/",
        params: {
          destinationType: this.destinationType,
        },
      };

      getRequest(payload).then((response) => {
        this.showLoading = false;

        if (response.model && response.model.length) {
          this.hotelList = modelMapper(response.model);

          if (!this.defaultList.length && !this.inputValue.length) {
            this.defaultList = this.hotelList;
          }
        } else {
          this.notFound = true;
          this.message = "موردی یافت نشد";
        }
      });
    },

    // set input value and set search link
    setValue(hotel) {
      this.inputValue = hotel.title;
      this.showList = false;
      this.selectedHotel = true;
      this.hotel = hotel;
      this.temp = "";

      if (window.innerWidth < 993) {
        root.classList.remove("no-scroll");
      }

      this.$emit("remove-search-holder-z-index");

      this.$emit("fill-next-input");
    },

    setInitialValue(hotel) {
      this.inputValue = hotel.title;
      this.selectedHotel = true;
      this.hotel = hotel;
      this.temp = "";
    },

    // clear input value
    clearInput() {
      this.inputValue = "";
      this.selectedHotel = false;
      this.hotel = "";
    },

    // close dropdown when click out of booking section
    close() {
      if (this.showList) {
        this.showList = false;

        if (window.innerWidth < 993) {
          root.classList.remove("no-scroll");
        }

        if (this.temp) {
          this.inputValue = this.temp;
        }

        this.$emit("remove-search-holder-z-index");
      }

      if (!this.selectedHotel) {
        this.temp = "";
        this.inputValue = "";
        this.hotel = "";
      }
    },
  },

  mounted() {
    if (window.searchInitialize) {
      this.setInitialValue(window.searchInitialize.search.destinations);
    }
  },

  directives: {
    "click-outside": clickOutside,
  },
};
</script>
